module.exports = __webpack_public_path__ + "img/42Clinton.d54f2d6f.png";